import { render, staticRenderFns } from "./order-sumary.vue?vue&type=template&id=353267f1&"
import script from "./order-sumary.vue?vue&type=script&lang=js&"
export * from "./order-sumary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports